import React from 'react'
import { useState, useEffect, useContext, useMemo } from 'react';
 
import cogoToast from "cogo-toast";
import { FaCheckCircle, FaExclamationCircle, FaPrint, FaSearch, FaTimesCircle } from "react-icons/fa";
import * as SurveyCore from "survey-core";
import { Survey } from 'survey-react-ui';
import {  getList,postList,genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS } from "../../../Constants";
import AppContext from "../../../AppContext";
import { getListStaffDetailsRequestBody } from "../../../services/Utils";
import { Badge } from 'react-bootstrap';
 

const ToilDetails = (props) => {
  const { data } = (props.location && props.location.state) || {};

  const global = useContext(AppContext);

  const [IsLoading, setIsLoading] = useState(false)
const [leave_reason, setLeave_reason] = useState("")
    const [selectedDates, setSelectedDates] = useState([]);
    const [leave_type, setLeave_type] = useState(null)
    const [leave_types, setLeave_types] = useState([]);
const [staff_code, setstaff_code] = useState("")
const [staff_data, setstaff_data] = useState(null)
const [users, setUsers] = useState([])
const [approvalComments, setapprovalComments] = useState("")
const [supervisor, setSupervisor] = useState(null)
const [hr_staff, setHr_staff] = useState(null)
const [claimSubmitted, setClaimSubmitted] = useState(false)
 


const convert_date=(m)=>{
    var date = new Date(m);  
    var year = date.getFullYear();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
        
    let formatted=`${year}-${month}-${day}`; 
    return formatted;
}

useEffect(() => {
  listLeaveTypes();
  const staffRequest = getListStaffDetailsRequestBody(global.get_logged_in_user());
  listUsers();
  if (staffRequest) {
    load_staff_details(staffRequest);
  }
}, [])


const survey_Model = useMemo(() => {
  const template = {
    ...(data?.claim_template || {}),
    showCompletePage: false,
    completedHtml: "",
  };
  const model = new SurveyCore.Model(template);
  model.showCompletePage = false;
  model.completedHtml = "";
  return model;
}, [data?.claim_template]);
const listUsers =async ()=>{
  setIsLoading(true);
  setUsers( await getList(ENDPOINTS.LIST_USERS))
  setIsLoading(false);
} 
const claimToilRequest = (sender) => {
  const result = sender.data;

  const payload = {
    toil_id: data?.id,
    claim_data: result,
    claim_approver_1: result?.claim_approver_1,
    claim_approver_2: result?.claim_approver_2,
  };

  setIsLoading(true);

  genericPost(ENDPOINTS.CLAIM_TOIL_REQUEST, payload)
    .then((response) => {
      setIsLoading(false);
      if (response.status == 200) {
        if (response.data.status == SUCCESS_RESULT) {
          setClaimSubmitted(true);
          sender.mode = "display";
          cogoToast.success(response.data.message, {
            hideAfter: 5,
          });
        } else {
          cogoToast.error(response.data.message, {
            hideAfter: 5,
          });
        }
      }
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
      cogoToast.error("Something went wrong, please Try again. " + err, {
        hideAfter: 5,
      });
    });
};

const load_staff_details = (requestBody) => {
  if (!requestBody || (!requestBody.staff_code && !requestBody.staff_id)) {
    return;
  }

  setIsLoading(true);
  genericPost(ENDPOINTS.LIST_STAFF_DETAILS, requestBody)
    .then((res) => {
      if (res.status == 200) {
        if (res.data.status == SUCCESS_RESULT) {
          setstaff_data(res.data["data"]);
       
        } else {
          cogoToast.error(res.data.message, {});
        }
      } else {
        cogoToast.error("Connection error. Please try again.", {});
      }
      setIsLoading(false);
    })
    .catch((err) => {
      setIsLoading(false);
      cogoToast.error("Critical error occurred. Please try again.", {});
    });
};

const find_staff_by_code = (staff_id) => {
  if (!staff_id) {
    return;
  }

  load_staff_details({ staff_code: String(staff_id).trim() });
};

const approve_toil =(level,status,remarks)=>{
if (window.confirm("Are you sure to " + (status==10001?"Approve":"Reject")  +"  this Toil ?")){
 


let payload={
  "toil_id": data?.id,
  "action": level,
  "status": status,
  "remarks": remarks
}
 
console.log(payload);

  genericPost(ENDPOINTS.APPROVE_TOIL,payload)
  .then((res) => {
    
    setIsLoading(false);
    if (res.status == 200) {
 
      let responseData = res.data;
      if (res.data.status == SUCCESS_RESULT) {
        global.show_operation_result({success:true,msg:"Leave Form submitted Successfully"})

        cogoToast.success(responseData.message);
 
 
        }
      else
      {
        cogoToast.error(responseData.message);
      }
      } else {
        cogoToast.error(res.data.message, {});
      }
    
  })
  .catch((err) => {
    setIsLoading(false);
    cogoToast.error(err.toString(), {});

    console.log(err);
  });
}
}

 
const listLeaveTypes=async ()=>{
  setIsLoading(true);
  setLeave_types(await getList(ENDPOINTS.LEAVE_TYPES));
  setIsLoading(false);
} 



const PrintLeave = () => {
 
  var printContents = document.getElementById("print");

  let w = 600;
  let h = 700;

  var left = window.screen.width / 2 - w / 2;
  var top = window.screen.height / 2 - h / 2;
  var docprint = window.open(
    "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
      w +
      ", height=" +
      h +
      ", top=" +
      top +
      ", left=" +
      left
  );

  docprint.document.open();
  docprint.document.write(`<head><style>
  table{
    border-collapse:collapse !important;
  }
  table {
    width: 95% !important;
    margin: auto !important;
  }
   
   td {
    border: 1px solid rgba(200, 198, 198, 0.452);
    text-align: left;
    border: 1px solid gray;
    padding: 5px !important;
    color: #000000 !important;
  }</style></head>   `);

  docprint.document.write(printContents.innerHTML);
 
 


  setTimeout(() => {

    docprint.print();
  }, 700);
  setTimeout(() => {

    docprint.close();
  }, 900);

  return;


 
//window.print("a4_invoice");
};
 
const getMinDate=()=>{
  try{
  var date = new Date();
 

 

return  date.setDate(date.getDate() - 1) ;
  }catch(e){alert(e)}
//.addDays(-1);
 
}

const handleDateChange = (dates) => {
   
    
    setSelectedDates(dates);
  };
  return (
    <div className="page-wrapper" style={{width:"60%",margin:"auto"}}>
 
 
       
 <h1>Toil Detail</h1>
        <div className="page-body">
          <div className="container-xl">
            <div className="card">
            
             
              <div className="card-header">
                
              <button onClick={()=>PrintLeave()} className='btn btn-primary'><FaPrint> </FaPrint> &nbsp;&nbsp; Print </button>
            </div>
                  
                   
               
                  <div className="card-body" id="print">
                  <center>
               
                  <img
              src="/images/logo.jpg"
              id="icon" 
            /> 
                  <h1> ISLAMIC RELIEF </h1>
                  <hr/>
                  <h1> TOIL CLAIM FORM </h1>
                  
                </center>
                  {/* <div className="input-group">

                                <input type="text"   styles={{width:"200px"}} onChange={(e)=>setstaff_code(e.target.value)} className="form-control" placeholder='SOM XXXX'/>
                                
                              </div> */}

<hr/>
<table className="info_table" >


<tr>
  <td className="blue-bg">STAFF ID</td> <td>{data?.staff?.staff_id} </td>
  <td className="blue-bg">Staff Name </td> <td> {data?.staff?.staff_name}</td>
  
  </tr>
  <tr>
  <td className="blue-bg">Email Address</td> <td> {data?.staff?.email}</td>
  <td className="blue-bg"> Request Date </td>  <td>{data?.created_at} </td>
  
  </tr>
  <tr>
  <td className="blue-bg">Subject </td> <td> {data?.subject}</td>

  <td className="blue-bg">Description </td> <td> {data?.description}</td>
  </tr>
  <tr>
  <td className="blue-bg">Toil Days </td> <td>
     {JSON.parse(data?.toil_dates).map((d)=>{
    return <li>{d}</li>;
  })}</td>
  <td className="blue-bg">Number of Days </td> <td> {data?.total_toil_days}</td>
  </tr>

  
 
</table>
<br/><br/>
 <h1> Toil Claim Approval</h1>

 <table className="info_table">
  <thead>
    <th>Approval Level</th>
    <th>Status</th>
    <th>Comments</th>
    <th>Acted On.</th>

  </thead>

  <tr>
<td><b> {data?.claim_approver_1_staff?.staff_name}  </b> <br/>
{data?.claim_approver_1_staff?.role} </td>
<td>

{ data?.claim_approver_1_status==10000?<span><FaExclamationCircle style={{color:"grey"}}></FaExclamationCircle> &nbsp;Pending 
<br/>
<input type='text' className='form-control' onChange={(e)=>setapprovalComments(e.target.value)} ></input>

<Badge className='badge red' onClick={()=>approve_toil(3,10001,approvalComments)}>Approve</Badge> &nbsp;&nbsp; &nbsp;&nbsp;
<Badge className='red' onClick={()=>approve_toil(3,10002,approvalComments)}>Reject</Badge>
 </span>:
 data?.claim_approver_1_status==10002? <span><FaTimesCircle style={{color:"red"}}></FaTimesCircle> &nbsp; Rejected </span> :
 <div> <FaCheckCircle style={{color:"green"}}></FaCheckCircle> Approved </div>
}

</td>
<td>{data?.claim_approver_1_remarks}</td>
<td>{data?.claim_approver_1_date}</td>


  </tr>
  <tr>
<td><b> {data?.claim_approver_2_staff?.staff_name}  </b> <br/>
{data?.claim_approver_2_staff?.role} </td>   
<td>

{ data?.claim_approver_2_status==10000?<span><FaExclamationCircle style={{color:"grey"}}></FaExclamationCircle> &nbsp;Pending  

<br/> 
<input type='text' className='form-control' onChange={(e)=>setapprovalComments(e.target.value)} ></input>

<Badge className='badge red' onClick={()=>approve_toil(4,10001,approvalComments)}>Approve</Badge> &nbsp;&nbsp; &nbsp;&nbsp;
<Badge className='red' onClick={()=>approve_toil(4,10002,approvalComments)}>Reject</Badge>
</span>:
 data?.claim_approver_2_status==10002? <span><FaTimesCircle style={{color:"red"}}></FaTimesCircle> &nbsp; Rejected </span> :
 <div> <FaCheckCircle style={{color:"green"}}></FaCheckCircle> Approved </div>
}

</td>
<td>{data?.claim_approver_2_remarks}</td>
<td>{data?.claim_approver_2_date}</td>


  </tr>
 </table>



<br/><br/>


{data?.claim_approver_1_status==10001 && data?.claim_approver_2_status==10001 && 
<>
 <h1> Fill Claim Form</h1>
 {claimSubmitted && (
   <div className="alert alert-success" role="alert">
     <FaCheckCircle className="me-2" />
     Claim form submitted successfully. Your responses are shown below.
   </div>
 )}
 <Survey
   model={survey_Model}
   onCompleting={(sender, options) => {
     options.allowComplete = false;
     claimToilRequest(sender);
   }}
 />
 </>
}




 












 

                  </div>
  
 
 
                   
           
              </div>
            </div>
          </div>
        </div>
       
     
  )
}

export default ToilDetails